import { UiNewsletter } from "libs/raas-ui-react-components/src/components";
import { useTranslation } from "react-i18next";
import { getNewsletterLiterals } from "./NewsLetter.service";

export default function NewsletterComponent(props: any) {

    // Aqui se estaba usando JSON.stringify que no debería de usarse!!!!!! 
    // Porque no funciona con las traducciones
    const [t, i18n] = useTranslation("global"); 

    const literalsNewsletter = getNewsletterLiterals(t);

    return (
        <>
            <UiNewsletter literals={literalsNewsletter}></UiNewsletter>
        </>

    )
}
